export default function LeftArrow({
                                    width = '24',
                                    height = '24',
                                    opacity,
                                    cursor,
                                    onClick,
                                    stroke = '#393939',
}) {
  return (
    <svg
        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        opacity={opacity}
        cursor={cursor}
        onClick={onClick}
    >
      <path d="M15 18L9 12L15 6" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}